import { formatNumberLocalized, truncateDecimals } from '@shared/helpers/formatters';
import { concatCurrencyToAmount } from '@shared/helpers/web3/formatters';

import { PredictionEntry, PredictionMyResult } from './PredictionEntry';

export const calculateTotalResults = (data: PredictionEntry[]): PredictionMyResult[] => {
  const { totalReward, timesWon } = data.reduce(
    (acc, item) => {
      const wonAmount = item.wonAmount.value;

      acc.totalReward += wonAmount;

      if (wonAmount > 0) {
        acc.timesWon++;
      }

      return acc;
    },
    { totalReward: 0, timesWon: 0 },
  );

  const timesPlayed = data.length;

  const winRate = timesPlayed > 0 ? (timesWon / timesPlayed) * 100 : 0;

  return [
    {
      id: 'totalReward',
      label: 'My Total Reward',
      value: `${concatCurrencyToAmount(formatNumberLocalized(totalReward), 'USDT', {
        stableToDollar: false,
      })}`,
    },
    { id: 'timesPlayed', label: 'Times Played', value: formatNumberLocalized(timesPlayed) },
    { id: 'timesWon', label: 'Times Won', value: formatNumberLocalized(timesWon) },
    { id: 'winRate', label: 'Win Rate', value: `${truncateDecimals(winRate, 2)}%` },
  ];
};
